import { ReactNode } from 'react'
import { cn } from '$components'

export type ModalFooterProps = {
  children?: ReactNode,
  className?: string,
}

export function ModalFooter({ children, className }: ModalFooterProps) {
  return (
    <div className={cn('flex p-6 w-full border-t border-gray-100 justify-end', className)}>
      { children }
    </div>
  )
}
